var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconFire = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 48,
  viewBox: "0 0 34 48",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.24739 47.9994C3.91164 30.4173 15.1859 23.9976 15.1859 23.9976C14.3971 33.3796 19.7287 40.6888 19.7287 40.6888C21.6895 40.0972 25.4323 37.3321 25.4323 37.3321C25.4323 40.6888 23.4574 47.9952 23.4574 47.9952C23.4574 47.9952 30.3708 42.6496 32.5471 33.7712C34.7205 24.8927 28.4071 15.9793 28.4071 15.9793C28.7876 22.2633 26.6617 28.4438 22.4966 33.1656C22.7049 32.925 22.8798 32.6579 23.014 32.3684C23.7623 30.8718 24.9637 26.9823 24.2602 17.9751C23.27 5.33156 11.8139 0 11.8139 0C12.8013 7.70362 9.8404 9.47848 2.90463 24.1011C-4.03115 38.7209 9.24739 47.9994 9.24739 47.9994Z"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconFire, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_fire.e8a65711.svg";
export { ForwardRef as ReactComponent };